import { useCallback, useMemo } from 'react';
import { convertListToArray } from '../../shared/utils/immutable';
import { ensureChildTeamsAppearSelected, normalizeTeamSelections } from '../utils/select-teams';
// NOTE: this hook intentionally does not grab teams from `useTeams`/`useRoutableTeams` because
// consumers could provide their own list of teams, such as with `RoutableUsersAndTeamsSelect`
export const useSelectedUsersAndTeams = ({
  teamIds: selectedTeamIds = [],
  teams,
  userIds: selectedUserIds = []
}) => {
  const teamIds = useMemo(() => Array.from(ensureChildTeamsAppearSelected(selectedTeamIds, teams)), [selectedTeamIds, teams]);
  const selectedIds = useMemo(() => teamIds.concat(convertListToArray(selectedUserIds)), [teamIds, selectedUserIds]);
  const normalizeTeams = useCallback(newTeamIds => normalizeTeamSelections(teamIds, newTeamIds, teams), [teamIds, teams]);
  return {
    selectedIds,
    normalizeTeams
  };
};